<script lang="ts">
	import { DataHandlerCalibration, Device } from "luxedo-data"
	import Guides from "luxedo-data/src/data/Guides"
	import { Reactivity } from "luxedo-reactivity"
	import { Responsive } from "responsive"
	import { tooltip } from "tooltip"

	interface Props {
		device: Device
		isCalibrated: boolean
		beginCalibration: () => void
	}

	let { device, isCalibrated, beginCalibration }: Props = $props()

	$effect.pre(() => {
		Reactivity.useProps(device, ["isOnline"])
	})

	let isOnline = $derived(Reactivity.propOf(device, "isOnline"))

	const OFFLINE_TEXT = `Your device must be online to calibrate.`
	const NO_CAL_TEXT = `This device has not yet been calibrated, ${Responsive.isMobile ? "tap" : "click"} "Calibrate Projector" to get started.`
	const FAILED_CAL_TEXT = `This device has not yet been successfully calibrated. If you running into issues when calibrating, check out <a target="_blank" href="${Guides["Device"]["Troubleshooting Calibration"]}">this article</a>.`

	/**
   * May need to determine isCalibrated a bit more explicitly
   * 
   * 
  onMount(() => {
		DataHandlerCalibration.addListener(onCalibrationListUpdate)
	})

	onDestroy(() => DataHandlerCalibration.removeListener(onCalibrationListUpdate))
  */
</script>

<div class="projector-section">
	<div class="flex-row">
		<h2 class="setting-heading">About Calibration</h2>

		<button
			id="calibrate-button"
			class="outline-button"
			onclick={beginCalibration}
			disabled={!isOnline}
			use:tooltip={{
				content:
					"Calibration is the process of shining and capturing patterns from your Luxedo in order to accurately map your projection space.",
				pointing: "top",
			}}>{isCalibrated ? "Rec" : "C"}alibrate</button
		>
	</div>
	<div class="cal-info">
		{#if !isCalibrated || !isOnline}
			<div class="warn-text">
				{#if !isOnline}
					{@html OFFLINE_TEXT}
				{:else if DataHandlerCalibration.filterByDevice(device).length}
					{@html FAILED_CAL_TEXT}
				{:else}
					{@html NO_CAL_TEXT}
				{/if}
			</div>
		{/if}
		Calibration is an automated process where your Luxedo will project patterns while capturing images
		of the projection. Once captured, the images will be processed to create a snapshot that truly reflects
		your projection space. This snapshot will be used as a guide to create your shows. You can learn
		more
		<a target="_blank" href={Guides.Device["Calibrating Your Device"]}>here </a>.
	</div>
</div>

<style>
	.projector-section {
		margin-bottom: 0.25rem;
	}

	.projector-section .flex-row {
		justify-content: space-between;
	}

	.cal-info {
		margin-bottom: 0;
		margin-top: 0.5rem;
		line-height: 1.25em;
		color: var(--color-text);
	}

	.warn-text {
		margin-bottom: 0.5rem;
	}
</style>
